const DEFAULT_OPTIONS = {
  decimals: 2,
  append: '',
  prepend: '',
}

const DEFAULT_FILTERS = {
  rateType: 'apr',
  term: null,
  variable: false,
}

export const getMinMaxRates = ({ lender, filters = {} }) => {
  const filter = {
    ...DEFAULT_FILTERS,
    ...filters,
  }

  const minRate = global.ratesLibrary.getRateValue(
    { lenderSlug: lender.rateSlug, name: 'min', ...filter },
    DEFAULT_OPTIONS,
  )
  const maxRate = global.ratesLibrary.getRateValue(
    { lenderSlug: lender.rateSlug, name: 'max', ...filter },
    DEFAULT_OPTIONS,
  )

  return { minRate, maxRate }
}

const filterByCreditScore = (creditScore) => (lender) =>
  !creditScore || lender.minCreditScore <= creditScore

export const filterByLoanAmount =
  (loanAmount) =>
  ({ minLoanAmount, maxLoanAmount }) =>
    !loanAmount || (minLoanAmount <= loanAmount && (!maxLoanAmount || maxLoanAmount >= loanAmount))

export const filterLender = (lenders, creditScore, loanAmount) => {
  return lenders.filter(filterByCreditScore(creditScore)).filter(filterByLoanAmount(loanAmount))
}

export const filterLendersWithFixedRates = ({ lenders, filters }) => {
  return lenders.filter((lender) => {
    const { minRate: minFixedRate, maxRate: maxFixedRate } = getMinMaxRates({
      lender,
      filters,
    })

    return minFixedRate && maxFixedRate
  })
}

export const compareLenders = (a, b) => {
  if (
    Math.min(
      a.minFixedRate ? a.minFixedRate : Infinity,
      a.minVariableRate ? a.minVariableRate : Infinity,
    ) >
    Math.min(
      b.minFixedRate ? b.minFixedRate : Infinity,
      b.minVariableRate ? b.minVariableRate : Infinity,
    )
  )
    return 1
  if (
    Math.min(
      b.minFixedRate ? b.minFixedRate : Infinity,
      b.minVariableRate ? b.minVariableRate : Infinity,
    ) >
    Math.min(
      a.minFixedRate ? a.minFixedRate : Infinity,
      a.minVariableRate ? a.minVariableRate : Infinity,
    )
  )
    return -1

  return 0
}

export const loadLendersRates = ({ availableLenders, filters, sortCallback = compareLenders }) => {
  const lenders = []

  const filteredLenders = filterLendersWithFixedRates({ lenders: availableLenders, filters })

  filteredLenders.forEach((lender) => {
    const { minRate: minVariableRate = undefined, maxRate: maxVariableRate = undefined } =
      lender.displayVariableRates
        ? getMinMaxRates({
            lender,
            filters: { ...filters, variable: true },
          })
        : {}

    const { minRate: minFixedRate, maxRate: maxFixedRate } = getMinMaxRates({
      lender,
      filters: { ...filters, variable: false },
    })

    lenders.push({ minFixedRate, maxFixedRate, minVariableRate, maxVariableRate, ...lender })
  })

  return sortCallback ? lenders.sort(sortCallback) : lenders
}
